import { LocalStoreService } from "./LocalStoreService";

export class RedirectV2Service {
    LocalStoreService = new LocalStoreService();
    constructor() {}

    redirect({
        accountingId,
        source = null,
        companyId = null,
        routeId = null
    }) {
        const baseUrl = publicSettings.urlV2;
        const refreshToken = this.LocalStoreService.getItem(
            "nucont:refresh_token"
        );
        let url = `${baseUrl}/auth/live?accId=${accountingId}&rwt=${refreshToken}`;
        if (source) {
            url += `&source=${source}`;
        }
        if (routeId) {
            url += `&routeId=${routeId}`;
        }
        if (companyId) {
            url += `&companyId=${companyId}`;
        }

        window.location.href = url;
    }

    getUrl({ accountingId, source = null, companyId = null, routeId = null }) {
        const baseUrl = publicSettings.urlV2;
        const refreshToken = this.LocalStoreService.getItem(
            "nucont:refresh_token"
        );
        let url = `${baseUrl}/auth/live?accId=${accountingId}&rwt=${refreshToken}`;
        if (source) {
            url += `&source=${source}`;
        }
        if (routeId) {
            url += `&routeId=${routeId}`;
        }
        if (companyId) {
            url += `&companyId=${companyId}`;
        }
        return url;
    }

    getUrlBeta({ accountingId, next = null }) {
        const refreshToken = this.LocalStoreService.getItem(
            "nucont:refresh_token"
        );
        let url = `https://betta.nucont.com/auth/live?accId=${accountingId}&rwt=${refreshToken}`;
        if (next) {
            url += `&next=${next}`;
        }
        return url;
    }
}
